// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class Form2View extends JQueryView {
  constructor() {
    super('.simple_form');

    this.renderAdditionalForm();
  }

  @on({
    event: 'change',
    selector: '#white_paper_download_user_information_source',
  })
  onChangeInformationSource() {
    this.renderAdditionalForm();
  }

  renderAdditionalForm() {
    $('.white_paper_download_user_information_source_note').css(
      'display',
      $('#white_paper_download_user_information_source').val() == 'other'
        ? 'block'
        : 'none',
    );
  }
}
